import { fetchCustomerData } from '@Services/init/partnerWelcome.api.ts';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { router } from '@Routes/__root';
import { CustomerData, CustomerDataSchema, MAIN_INCOME_SOURCE } from '@Store/index';
import { useBoundStore } from '@Store/useBoundStore';

const isStepNameValid = (stepName: string): stepName is keyof typeof routesModel => {
  return stepName in routesModel;
};

export const reArrangeNavigationStack = async (stepName: string) => {
  const { getCustomerData } = useBoundStore.getState();

  const navigationStack = useBoundStore.getState().onboardingSlice.navigationStack;
  const setPickupWhereLeftNavigationStack =
    useBoundStore.getState().onboardingSlice.setPickupWhereLeftNavigationStack;

  const index = navigationStack.findIndex((step) => step === stepName);
  if (index !== -1) {
    const currentData = getCustomerData();

    const enrichedCustomerData = await fetchCustomerData();
    updateCustomerDataFromServer(enrichedCustomerData, currentData);
  }

  const incomeSource = getCustomerData().customerData.customerBusinessData.mainIncomeSource;
  if (
    incomeSource == MAIN_INCOME_SOURCE.SOLE_PROP_NO_DBA ||
    incomeSource == MAIN_INCOME_SOURCE.SOLE_PROP_DBA ||
    incomeSource == MAIN_INCOME_SOURCE.SINGLE_MEMBER_LLC
  ) {
    adjustNavigationStackAccordingToIncomeSource(incomeSource);
  }
  if (!isStepNameValid(stepName)) {
    router.navigate({ to: routesModel.WELCOME.path });
    return;
  }
  setPickupWhereLeftNavigationStack(navigationStack);

  router.navigate({ to: routesModel[navigationStack[index || 0]].path });
};

export const updateCustomerDataFromServer = (
  enrichedCustomerData: Partial<CustomerData>,
  currentData: CustomerData
) => {
  const { setCustomerData } = useBoundStore.getState();
  const parsedEnrichedData = CustomerDataSchema.partial().parse(enrichedCustomerData);
  const mergedData = {
    ...currentData,
    ...parsedEnrichedData,
    customerData: {
      ...currentData.customerData,
      ...parsedEnrichedData.customerData,
    },
  };
  setCustomerData({ ...mergedData } as CustomerData);
};

export const adjustNavigationStackAccordingToIncomeSource = (
  mainIncomeSource: MAIN_INCOME_SOURCE
) => {
  const {
    onboardingSlice: { setNavigationStack, navigationStack },
  } = useBoundStore.getState();

  if (mainIncomeSource === MAIN_INCOME_SOURCE.SINGLE_MEMBER_LLC) {
    const routesToRemove = [RoutesMap.OWNER_CENTER];
    const navigationStackToUpdate = navigationStack.filter(
      (route) => !routesToRemove.includes(route)
    );
    setNavigationStack(navigationStackToUpdate);
  } else if (mainIncomeSource === MAIN_INCOME_SOURCE.SOLE_PROP_DBA) {
    if (!navigationStack.includes(RoutesMap.KNOW_YOUR_BUSINESS)) {
      const index = navigationStack.indexOf(RoutesMap.INDUSTRY);
      navigationStack.splice(index + 1, 0, RoutesMap.KNOW_YOUR_BUSINESS);
    }
    const routesToRemove = [RoutesMap.OWNER_CENTER, RoutesMap.BUSINESS_ADDRESS];
    const navigationStackToUpdate = navigationStack.filter(
      (route) => !routesToRemove.includes(route)
    );

    setNavigationStack(navigationStackToUpdate);
  } else if (mainIncomeSource === MAIN_INCOME_SOURCE.SOLE_PROP_NO_DBA) {
    const routesToRemove = [
      RoutesMap.OWNER_CENTER,
      RoutesMap.KNOW_YOUR_BUSINESS,
      RoutesMap.BUSINESS_ADDRESS,
    ];
    const navigationStackToUpdate = navigationStack.filter(
      (route) => !routesToRemove.includes(route)
    );
    setNavigationStack(navigationStackToUpdate);
  }
};
